module.exports = __webpack_public_path__ + "src/asset/svg/booking.svg?1d1516d301eb2efb3eea3ab5b8fd8bbe";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/booking.svg
// module id = 83
// module chunks = 0